<template>
        <div class="header">
      <img src="@/assets/headerDesafio.png" />
    </div>
<div class="contenedor fondo text-center">
    <div class="row mx-auto col-sm-12 desktop">
        <div>
            <img src="@/assets/opps.png" alt="" style="width:60%; margin-top:5%;">
        </div>

    </div>

</div>

</template>

<script>
export default {
   created(){
      window.scrollTo(0,0);
    }
}
</script>
